import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import { FaPhone } from "react-icons/fa";
import LOGO from "../../assets/logos/flipcity-logo.png";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/gallery", label: "Gallery" },
  { to: "/classes", label: "Classes" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

const Navbar = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location, setMobileMenuOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileMenuOpen
          ? "bg-white shadow-md py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src={LOGO} alt="Flipcity Gymnastics Academy" className="h-10 sm:h-12 w-auto" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 ${
                  scrolled || mobileMenuOpen
                    ? location.pathname === link.to
                      ? "text-primary-600"
                      : "text-slate-600 hover:text-primary-600"
                    : location.pathname === link.to
                      ? "text-white"
                      : "text-white/80 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+919582691655"
              className={`inline-flex items-center gap-2 text-sm font-medium px-5 py-2.5 rounded-lg transition-colors duration-200 ${
                scrolled || mobileMenuOpen
                  ? "bg-primary-600 hover:bg-primary-700 text-white"
                  : "bg-white text-slate-900 hover:bg-white/90"
              }`}
            >
              <FaPhone className="text-xs" />
              Call Now
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className={`md:hidden p-2 transition-colors ${scrolled || mobileMenuOpen ? "text-slate-600 hover:text-primary-600" : "text-white hover:text-white/80"}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <HiX className="text-2xl" />
            ) : (
              <HiMenu className="text-2xl" />
            )}
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-slate-100">
            <div className="flex flex-col gap-1 pt-4">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === link.to
                      ? "bg-primary-50 text-primary-600"
                      : "text-slate-600 hover:bg-slate-50"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:+919582691655"
                className="mx-4 mt-2 inline-flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium px-5 py-3 rounded-lg transition-colors"
              >
                <FaPhone className="text-xs" />
                +91 95826 91655
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
